import { render } from "./IllnessIcon.vue?vue&type=template&id=7b1619ac"
import script from "./IllnessIcon.vue?vue&type=script&lang=js"
export * from "./IllnessIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__